export default {
      id: "fb-rounded-usage",
      viewBox: "0 0 24 24",
      url: "../../assets/" + "sprite.svg#fb-rounded-usage",
      toString: function () {
        return this.url;
      }
    }